export default {
  settings: JSON.parse(localStorage.getItem('user-settings')) || {
    darkTheme: false,
    voiceName: '',
    userName: '',
    lang: 'fr-FR',
    path: null, // current path id related to linestrings
    line: null, // current linestring id related to position
    follow: false // should map center track user or not
  },
  voices: window.speechSynthesis.getVoices(),
  langs: ['fr-FR', 'en-US']
}
